import { useMutation } from '@tanstack/react-query';

import { handleError, handleSuccess } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { getApiErrorMessage } from '../../../../logic';
import { ApiErrorResponse } from '../../../../types';
import { postResetUserTwoFactor } from '../../requests/postResetUserTwoFactor';

export const useResetUserTwoFactor = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (userId: string) =>
      postResetUserTwoFactor(constructPost, userId),
    onSuccess: () => handleSuccess('Two factor authentication reset.'),
    onError: (error: ApiErrorResponse) =>
      handleError(
        getApiErrorMessage(error, 'Failed to reset two factor authentication.'),
      ),
  });
  return { resetUserTwoFactor: mutateAsync, ...rest };
};
